import Component from '../core/Component'
import YoutubePlayer from 'youtube-player'

export default class ModalVideo extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            video: null,
            iframe: null
        }

        this.player = null
        this.isActive = false
    }

    prepare() {
        this.modal = Component.getFromElement(this.element.closest('[data-component="Modal"]'))

        if (!this.modal) {
            return
        }

        this.modal.on('afteropen', this.handleModalOpen)
        this.modal.on('close', this.handleModalClose)

        window.addEventListener('resize', this.handleResize)
    }

    destroy() {
        if (this.ref.video) {
            this.ref.video.pause()
        }

        if (this.player) {
            this.player.stopVideo()
        }

        window.removeEventListener('resize', this.handleResize)
    }

    handleResize = () => {
        this.resize()
    }

    handleModalOpen = () => {
        this.isActive = true
        this.resize()

        if (this.ref.video) {
            this.ref.video.play()
        }

        if (this.ref.iframe && !this.player) {
            this.player = new YoutubePlayer(this.ref.iframe)
            this.player.on('ready', this.handlePlayerReady)
        } else if (this.player) {
            this.player.playVideo()
        }
    }

    handlePlayerReady = () => {
        if (this.isActive) {
            this.player.playVideo()
        }
    }

    handleModalClose = () => {
        this.isActive = false

        if (this.ref.video) {
            this.ref.video.pause()
        }

        if (this.player) {
            this.player.stopVideo()
        }
    }

    resize() {
        const box = this.element.getBoundingClientRect()
        let width = 0.9 * Math.min(window.innerHeight / box.height * box.width, window.innerWidth)
        this.element.style.width = `${width}px`
    }


}